// Service for employee basic operations (hierarchy-filtered list)
import { apiClient, API_CONFIG } from '../../../core';
import type { ApiResponse } from '../../../shared';
import { buildQueryString } from '../../../shared/queryBuilder';
import type {
  LC_GetEmployeeBasicIn,
  LC_EmployeeBasicData,
  EmployeeBasicPage,
} from '../types/employeeBasic.types';
import { mapEmployeeBasicPage } from '../mappers/employeeBasic.mapper';


export class EmployeeBasicService {
  /**
   * Get basic employee list filtered by user hierarchy
   * Returns employees that the logged-in user can see based on their role
   * GET /v{version}/employees/basic
   */
  async getBasic(params?: LC_GetEmployeeBasicIn): Promise<ApiResponse<EmployeeBasicPage>> {
    const queryString = buildQueryString(params ?? {});
    const endpoint = `${API_CONFIG.ENDPOINTS.EMPLOYEES.BASIC}${queryString}`;
    
    const response = await apiClient.get<LC_EmployeeBasicData>(endpoint);

    if (response.success && response.data) {
      return {
        ...response,
        data: mapEmployeeBasicPage(response.data),
      };
    }

    return { ...response, data: null };
  }
}

export const employeeBasicService = new EmployeeBasicService();
